import { render, staticRenderFns } from "./ModalSlot2.vue?vue&type=template&id=7bab3f88"
import script from "./ModalSlot2.vue?vue&type=script&lang=js"
export * from "./ModalSlot2.vue?vue&type=script&lang=js"
import style0 from "./ModalSlot2.vue?vue&type=style&index=0&id=7bab3f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports